// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"11":"membercard","95":"handle-transfer","443":"about","571":"settings","584":"block","805":"transactions","809":"transfer"}[chunkId] + "-legacy." + {"11":"d63442fd","95":"a4d9cdbc","443":"a0f72758","571":"9a704f6b","584":"7da14ca0","805":"3178d7dc","809":"d8f748da"}[chunkId] + ".js";
};